
export const getPlayingSong = state => state.player.song;

export const getQueue = state => state.player.queue

export const isPlaying = state => state.player.playing;

export const isShaffled = state => state.player.shuffled;

export const isMuted = state => state.player.muted;

export const getRepeat = state => state.player.repeat;
